/* eslint-disable */
export default {
  to: 'À',
  enterNameOrNumber: 'Entrez un nom ou un numéro',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
